import type {
    AssetLocation,
    TemplateMetadata,
} from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncStatus } from "@react-hookz/web";

export interface RequestParameters {
    [key: string]: string;
}

export interface InputParameterFilter {
    /**
     * column name
     */
    key: string;

    /**
     * dimension id to fetch value
     */
    dimension?: string;
    value?: string | string[];
    condition: Comparator;
    type?: string;
}

export interface OrderBy {
    key: string;
    sort: Sort;
}

export enum Sort {
    ASC = "ASC",
    DESC = "DESC",
}

export interface Filter {
    key: string;
    value?: string;
    comparator: Comparator;
    values?: string[];
    type?: string;
}

export enum Comparator {
    EQUALS = "EQUALS",
    ILIKE = "ILIKE",
    NOT_EQUALS = "NOT_EQUALS",
    GE = "GE",
    GT = "GT",
    LE = "LE",
    LT = "LT",
    IN = "IN",
}

export type KeyValue = { [key: string]: any };

/**
 * Filter Item Type
 */
export type Item = {
    label: string;
    value: string | number;
    group?: string;
};

export const DEFAULT_ITEM: Item = {
    label: "Select An Option",
    value: "undefined",
};

export const DEFAULT_ALL_ITEM: Item = {
    label: "All",
    value: "",
};

export interface DownloadAsset {
    downloadUrl: string | undefined;
    content: AssetLocation | undefined;
    asyncStatus?: AsyncStatus;
    // For Marketing Narrative download
    contentId?: string;
    contentVersion?: string;
    hasRelevantInsightsDeck?: boolean;
    template?: TemplateMetadata | undefined;
}

export enum StatusTextState {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    LOADING = "LOADING",
}

export enum ACCOUNT_AGNOSTIC_IDS {
    NO_IDENTIFIER = "AccountAgnostic",
    WITH_IDENTIFIER = "AccountAgnosticWithIdentifier",
}
